import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms'; // ✅ add this
import { CommonModule } from '@angular/common';


import { ApiService } from 'src/services/apiService';
import { AuthService } from 'src/services/auth.service';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { TranslateModule,TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-otp',
  standalone: true, // ✅ THIS FIXES YOUR ERROR
  imports: [CommonModule, FormsModule,TranslateModule],
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.css']
})
export class OtpComponent {

  nationalId: string = '';
  password: string = '';
  otp: string = '';
  loading: boolean = false;
    lang: string;
  errorMessage: string = '';
  successMessage: string = '';
  countdown: number = 60;
canResend: boolean = false;
timerInterval: any;


  mainPath = environment.MainPath;; // change this
  backGroundImageSrc = environment.backGroundImageSrc; // change this

  constructor(private apiService: ApiService, private authService: AuthService, private cookieService: CookieService, private translate: TranslateService,) {
    this.lang = cookieService.get('lang');
  }

    ngOnInit(): void {
    this.startTimer();
  }

   changeLanguage() {

    this.lang == "ar" ? this.lang = "en" : this.lang = "ar";

    this.translate.use(this.lang);
    this.cookieService.set('lang', this.lang);

    setTimeout(() => {
      location.reload();
    }, 500);
  }

  startTimer() {
  this.canResend = false;
  this.countdown = 60;

  clearInterval(this.timerInterval);

  this.timerInterval = setInterval(() => {
    this.countdown--;

    if (this.countdown <= 0) {
      clearInterval(this.timerInterval);
      this.canResend = true;
    }
  }, 1000);
}

  verifyOtp() {
    this.errorMessage = '';
    this.successMessage = '';
    this.loading = true;

    const body = {
      nationalId: this.authService.getNationalNumber(), 
      password: this.authService.getNationalPass(),
      otp: Number(this.otp).toString() // Convert to number and back to string to remove leading zeros
    };

    this.apiService.post('Sso/VerifyOtp', body).subscribe({
      next: (res) => {
        this.loading = false;
        this.authService.setToken(res.data.access_token);
        this.authService.setRefreshToken(res.data.refresh_token);
        

        if (res.error === false) {
          this.successMessage = res.message;

          setTimeout(() => {
            location.href = '/' + this.mainPath + '/Dashboard';
          }, 800);
        } else {
          this.errorMessage = res.message || 'Something went wrong';
        }
      },
      error: (err) => {
        this.loading = false;
        this.errorMessage = err?.error?.message || 'Server error';
      }
    });
  }

 resendOtp() {

  if (!this.canResend) return;

  this.errorMessage = '';
  this.successMessage = '';

  const nationalId = this.authService.getNationalNumber();
  const password = this.authService.getNationalPass();

  this.apiService
    .get(`Sso/resendOtp?nationalId=${nationalId}&password=${password}`)
    .subscribe({
      next: (res) => {

        if (res.error === false) {
          this.successMessage = 'OTP resent successfully';
          this.startTimer();
        } else {
          this.errorMessage = res.message || 'Something went wrong';
        }

      },
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Server error';
      }
    });
}
}
